<app-split-screen-form-based-modal [config]="formConfig$ | async" (submitForm)="onSubmit()">
  <div slot="header-content">
    <div class="logo-container">
      <svg-icon icon="pencil_spaces" width="170" height="30"></svg-icon>
    </div>
  </div>

  <!-- Form Content -->
  <div slot="form-content">
    <!-- Header Section -->
    <div class="split-screen-header-section">
      <div class="split-screen-main-title">
        {{ 'One last step!' | translate }}
      </div>
      <div class="split-screen-subtitle">
        {{ 'We need a few more details to finalize your upgrade' | translate }}
      </div>
    </div>

    <form [formGroup]="form" class="form-container">
      <!-- Institution Name Field -->
      <div class="form-control-row">
        <label for="institution-name" class="input-label">{{
          'Institution Name' | translate
        }}</label>
        <input
          id="institution-name"
          type="text"
          class="dialog-text-input"
          formControlName="name"
          placeholder="{{ 'Quick Learning Academy' | translate }}"
          required
        />
        <div
          class="mat-error"
          *ngIf="form.get('name')?.errors?.['required'] && form.get('name')?.touched"
        >
          {{ 'Institution name is required' | translate }}
        </div>
        <div class="mat-error" *ngIf="form.get('name')?.errors?.['maxlength']">
          {{ "Name should not exceed {{maxLength}} characters" | translate: {maxLength:
          MAX_ENTITY_TITLE_LENGTH} }}
        </div>
      </div>
    </form>
  </div>

  <!-- Preview Content -->
  <div slot="preview-content" style="display: flex">
    <div class="split-screen-preview-card">
      <!-- First Row: Logo Section -->
      <div class="preview-logo-section">
        <!-- Logo preview using the actual Pencil app icon -->
        <div class="pencil-image-container size-medium rounded logo-preview-container">
          <!-- Always show the Pencil Spaces app logo (same as browser icon) -->
          <div class="pencil-image-skeleton"></div>
        </div>
      </div>

      <!-- Second Row: Institution Name Section -->
      <div class="preview-institution-section">
        <div class="institution-name-container">
          <!-- Show actual name if available, otherwise show skeleton -->
          <div class="institution-name-content" *ngIf="institutionName; else nameSkeleton">
            <div class="institution-name-text">
              {{ institutionName }}
            </div>
          </div>
          <ng-template #nameSkeleton>
            <div class="institution-name-placeholder"></div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</app-split-screen-form-based-modal>
